import * as React from 'react';

/**
 * This component can be use to catch any errors rendered from the subtree. Use as following:
 * <ErrorBoundary>
 *   {(error, info) =>
 *     error ? (
 *       <Heading>There was an error</Heading>
 *      ) : (
 *        <YourPossiblyFailingComponent />
 *      )
 *    }
 * </ErrorBoundary>
 */ class ErrorBoundary extends React.Component {
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo
        });
    }
    render() {
        const { error , errorInfo  } = this.state;
        return this.props.children(error, errorInfo);
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: undefined,
            errorInfo: undefined
        };
    }
}

export { ErrorBoundary as default };
//# sourceMappingURL=ErrorBoundary.js.map
